import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { Login } from "./Login.tsx";
import "./index.css";

function Root() {
  const [me, setMe] = useState<{ email: string } | null | undefined>(undefined);
  useEffect(() => {
    fetch("/api/auth/me").then(async (r) => setMe(r.ok ? await r.json() : null), () => setMe(null));
  }, []);
  if (me === undefined) return null;
  if (!me) return <Login onSignedIn={(email) => setMe({ email })} />;
  return <App email={me.email} onSignedOut={() => setMe(null)} />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
